import { useEffect } from "react";
import { useTranslation } from "../../i18n/useTranslation";

// app.uselura.com is a utility surface (auth actions, Stripe returns, deep-link
// fallbacks). Direct visitors go to the marketing site — product decision 2026-07.
function Home() {
  const { tx } = useTranslation();
  useEffect(() => {
    window.location.replace("https://uselura.com");
  }, []);

  return (
    <div className="page">
      <p>{tx("home.redirecting", { site: <a href="https://uselura.com">uselura.com</a> })}</p>
    </div>
  );
}

export default Home;
